module.exports = __webpack_public_path__ + "img/ats.13b9b7bb.svg";